import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiHttpService } from 'src/app/Service/api.http.service';
import { APIEndPoints } from 'src/app/utils/api-endpoint';

@Injectable({
  providedIn: 'root',
})
export class MyFamilyService {
  public CurrentUserInfo: any;
  public familyInfo;
  public forceRefresh = false;
  constructor(private _apiService: ApiHttpService) {}

  UserTrustedProfessionals;

  GetMyFamilyInfo(): Observable<any> {
    if (this.familyInfo && !this.forceRefresh) return of(this.familyInfo);
    this.forceRefresh = false;
    return this._apiService.get(`${APIEndPoints.Family}/Members`).pipe(
      tap((resp) => {
        this.familyInfo = resp;
        return resp;
      })
    );
  }

  GetUserTrustedProfessionals(): Observable<any> {
    return this._apiService.get(`${APIEndPoints.User}/GetTrustedProfessional`).pipe(
      tap((resp) => {
        return resp;
      })
    );
  }

  GetFolderAccessMembers(folderId: string): Observable<any> {
    return this._apiService.get(`${APIEndPoints.Family}/FolderAccessMembers/${folderId}`).pipe();
  }

  GetFamilyUsers(): Observable<any> {
    return this._apiService.get(`${APIEndPoints.Family}/Users`).pipe(
      tap((resp) => {
        return resp;
      })
    );
  }
  deletePendingClient(id:any) {
    return this._apiService.delete(
      APIEndPoints.Professional + `/DeletePendingInvites/${id}`
    ).pipe();
  }

  deleteClient(data) {   
    return this._apiService.post(
      APIEndPoints.Professional + `/DeleteUserClient`,data
    ).pipe();
  }
  PostInviteMember(data) {
    return this._apiService
      .post(`${APIEndPoints.Family}/InviteMember`, data)
      .pipe();
  }

  PostInviteMemberV2(data) {
    return this._apiService
      .post(`${APIEndPoints.Family}/InviteMemberV2`, data)
      .pipe();
  }

  GetFolders(): Observable<any> {
    return this._apiService.get(`${APIEndPoints.Family}/Folders`).pipe();
  }

  GetBeneficiaryFiles(search = '', downloadBase = ''): Observable<any> {
    return this._apiService.post(`${APIEndPoints.Files}/GetBeneficiaryFiles`, {
      search,
      downloadBase,
    });
  }

  GetVaultSubFolders(userId: string): Observable<any> {
    const vaultId = 'F59BAA25-175B-4EB3-A76F-01806ED49357';
    return this._apiService
      .get(`${APIEndPoints.Family}/SubFolders/${vaultId}/${userId ?? ''}`)
      .pipe();
  }

  DeleteFamilyMember(userId) {
    this.forceRefresh = true;
    return this._apiService
      .delete(`${APIEndPoints.Family}/DeleteFamilyMember/` + userId)
      .pipe();
  }

  CancelInviteFamilyMember(inviteId) {
    this.forceRefresh = true;
    return this._apiService
      .delete(`${APIEndPoints.Family}/CancelInvite/` + inviteId)
      .pipe();
  }

  /** Re-sends a pending family invitation email. Backend endpoint:
   *  POST /api/Family/ResendInvitation/{invitationId}. The empty `{}`
   *  body is required because ApiHttpService.post expects one. */
  ResendInvitation(invitationId: string): Observable<any> {
    return this._apiService
      .post(`${APIEndPoints.Family}/ResendInvitation/${invitationId}`, {})
      .pipe();
  }
  GetRoles(){
    return this._apiService.get(`${APIEndPoints.Family}/Roles`).pipe();
  }
  GetRelations(): Observable<any> {
    return this._apiService.get(`${APIEndPoints.Family}/Relations`).pipe();
  }
  GetAccessRoles(): Observable<any> {
    return this._apiService.get(`${APIEndPoints.Family}/AccessRoles`).pipe();
  }
  GetProfessionalList(userId){
    return this._apiService.get(`${APIEndPoints.Professional}/ProfessionalList/`+userId).pipe();
  }
}
